

import React, { memo, useCallback } from 'react';
import cx from 'classnames';
import cxs from 'cxs';
import { COLORS } from '../constants/colors';
import getBackgroundColor from '../utils/getBackgroundColor';

import HeatmapCell from './HeatmapCell';
import { HEATMAP_VALUE_CELL_TOOL_TIP_LABEL } from '../constants/toolTipLabel';
import '../styles/_heatmap-value-cell.scss';








function getStyles({ colorNumber, videos, quota }) {
  const currentColorsKey = Object.keys(COLORS)[colorNumber];

  return cxs({
    backgroundColor: getBackgroundColor(
      { colorRGB: COLORS[currentColorsKey], usedVideosCount: videos.length, quota }
    )
  });
}

function HeatmapValueCell({ onCellClick, videos, colorNumber, quota }) {
  const isOverLimit = videos.length > quota;
  const hasVideos = videos.length > 0;
  const styles = getStyles({ colorNumber, videos, quota });

  const onClick = hasVideos && onCellClick && useCallback(() => onCellClick(videos), [videos]);

  return (
    <HeatmapCell
      className={cx(
        'heatmap-value-cell',
        { 'heatmap-value-cell--over-limit': isOverLimit },
        styles
      )}
      onCellClick={onClick}
      toolTipLabel={HEATMAP_VALUE_CELL_TOOL_TIP_LABEL}>

      {videos.length}
    </HeatmapCell>);

}

export default memo(HeatmapValueCell);